export default __webpack_public_path__ + "static/media/collapse-down.b9ad0cad.svg";